import Vue from "vue";
import App from "./App.vue";
import { firestorePlugin } from "vuefire";
import * as firebase from "firebase/app";

Vue.use(firestorePlugin);

Vue.config.productionTip = false;
(async () => {
  const firebaseInit = await fetch("/__/firebase/init.json");
  const firebaseConfig = await (async () => {
    if (process.env.NODE_ENV === "development") {
      // default for local development
      return {
        apiKey: "AIzaSyDAyCnA82HsPxzVr9UNPO4nlVi-ynz3_aM",
        authDomain: "karaoke-buddies-staging.firebaseapp.com",
        databaseURL: "https://karaoke-buddies-staging.firebaseio.com",
        projectId: "karaoke-buddies-staging",
        storageBucket: "karaoke-buddies-staging.appspot.com",
        messagingSenderId: "954423922739",
        appId: "1:954423922739:web:4f6197d5c9f72b69f41346",
        measurementId: "G-2T7V7KL5TJ",
      };
    } else {
      if (firebaseInit.ok) {
        return await firebaseInit.json();
      } else {
        if (process.env.NODE_ENV === "production") {
          throw new Error("Firebase config not detected. You must include it in /__/firebase/init.js");
        }
      }
    }
  })();
  firebase.initializeApp(firebaseConfig);

  const router = (await import("./router")).default;
  const store = (await import("./store")).default;
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount("#app");
})();
